import { useEffect } from 'react';

function isAndroid() {
  return typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent);
}
function isSmallIOS() {
  return typeof navigator !== 'undefined' && /iPhone|iPod/.test(navigator.userAgent);
}
function isLargeIOS() {
  return (
    typeof navigator !== 'undefined' &&
    (/iPad/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
  );
}
function isIOS() {
  return isSmallIOS() || isLargeIOS();
}
function isMobile() {
  return isAndroid() || isIOS();
}
function getMMDeeplink() {
  const currentUrl = window.location.host + window.location.pathname;
  const deeplink = `https://metamask.app.link/dapp/${currentUrl}`;

  return deeplink;
}

function getCoinbaseDeeplink() {
  const currentUrl = window.location.host + window.location.pathname;
  const deeplink = `https://go.cb-w.com/dapp?cb_url=${currentUrl}`;

  return deeplink;
}

function getExplicitInjectedProvider(flag: string) {
  const _window = typeof window !== 'undefined' ? window : void 0;
  if (typeof _window === 'undefined' || typeof _window.ethereum === 'undefined') return;
  const providers = _window.ethereum.providers;
  return providers
    ? providers.find((provider: any) => provider[flag])
    : _window.ethereum[flag]
      ? _window.ethereum
      : void 0;
}

function handleMetamaskLinkClick(event: MouseEvent) {
  const metamaskButton = (event.target as Element).closest(
    '[data-testid=rk-wallet-option-metaMask]',
  );
  if (metamaskButton && !window.ethereum) {
    event.stopImmediatePropagation();
    window.location.replace(getMMDeeplink());
  }
}

function handleCoinbaseLinkClick(event: MouseEvent) {
  const rainbowButton = (event.target as Element).closest(
    '[data-testid=rk-wallet-option-coinbase]',
  );
  if (rainbowButton && typeof getExplicitInjectedProvider('isCoinbase') == 'undefined') {
    event.stopImmediatePropagation();
    window.location.replace(getCoinbaseDeeplink());
  }
}

const useWalletButtonsInterceptor = () => {
  useEffect(() => {
    // only intercept on mobile devices
    if (isMobile()) {
      // passing true in the 3rd argument means listen in the capture phase
      document.addEventListener('click', handleMetamaskLinkClick, true);
      document.addEventListener('click', handleCoinbaseLinkClick, true);
    }

    return () => {
      document.removeEventListener('click', handleMetamaskLinkClick, true);
      document.removeEventListener('click', handleCoinbaseLinkClick, true);
    };
  }, []);
};

export default useWalletButtonsInterceptor;
